import { FunctionComponent } from "react";
import Avatar from "rivals/components/shared/Avatar";
import RivalsLink from "rivals/components/shared/Link";
import { MEDIA_BREAKPOINTS } from "rivals/media";
import styles from "./ForecasterThumbnail.module.scss";
import { OwnProps } from "./types";

const ForecasterThumbnail: FunctionComponent<OwnProps> = ({
  forecaster: {
    accuracy,
    firstName,
    forecasterTitle,
    lastName,
    profileImage,
    profileUrl
  }
}) => {
  return (
    <div className={styles.forecasterThumbnail}>
      <div className={styles.mobileTitle}>{forecasterTitle}</div>
      <div className={styles.forecasterBioBlock}>
        <div className={styles.forecasterPicture}>
          <Avatar
            alt={"forecaster profile"}
            mobileBreakpoint={MEDIA_BREAKPOINTS.MD}
            mobileSize={64}
            philter={"forecaster"}
            size={92}
            url={profileImage}
          />
        </div>
        <div className={styles.forecasterInformation}>
          <div className={styles.forecasterTitle}>{forecasterTitle}</div>
          <RivalsLink
            className={styles.forecasterName}
            data="futurecast-forecaster-profile"
            href={profileUrl}
          >
            <div>{firstName}</div>
            <div>{lastName}</div>
          </RivalsLink>
          <div className={styles.forecasterAccuracy}>{accuracy}% accuracy</div>
        </div>
      </div>
    </div>
  );
};

export default ForecasterThumbnail;
